import { Injectable } from "@angular/core";
import { UntypedFormArray, UntypedFormGroup } from "@angular/forms";

@Injectable({ providedIn: 'root' })
export class ScreensInterviewService{

    physicianForms: UntypedFormGroup[] = [];

    addForm(physicianForm: UntypedFormGroup) {
        this.physicianForms.push(physicianForm);
    }

    removeForm(physicianForm: UntypedFormGroup) {
        const idx = this.physicianForms.indexOf(physicianForm);

        this.physicianForms.splice(idx, 1);
    }

    arePhysicianFormsValid() : boolean{
        let result = true;

        this.physicianForms.forEach(x => {
            if (!x.valid) {
                result = false;
                x.markAllAsTouched();
                x.updateValueAndValidity();
            }

            if (x.valid) {
                const formArray = <UntypedFormArray> x.get('physcianDetails');

                formArray.controls.forEach((form: UntypedFormGroup) => {
                    if (formArray.valid && (form.controls["id"].value === '' || form.controls["id"].value === null || form.controls["id"] === undefined)) {
                        result = false;
                    }
                });
            }
        });

        return result;
    }
}